import { FormatOptionLabelContext } from "react-select";
import { IReactSelect } from "../model/interface/keyValuePair";
import { IDistrictOption } from "../model/interface/districts";

// District names repeat across states, so the menu needs the state to tell them apart when no state is picked.
export const formatDistrictOption = (
  option: IReactSelect | IDistrictOption,
  context: FormatOptionLabelContext,
  selectedStateId?: number
) =>
  context === "menu" && !selectedStateId && "stateName" in option
    ? `${option.label} (${option.stateName})`
    : option.label;
